import Component from "../../modules/abstracts/Component";
import {Swappable, Sortable} from '@shopify/draggable';

export default class VisualMerchandaisingComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-vm="true"]',
      codes: '[data-vm-code]:not([data-vm-code=""])',
      mainContainer: '.js-filters-result',
      swappableArea: () => {
        return document.querySelector(this.SELECTORS.main) ? document.querySelector(this.SELECTORS.main).dataset.vmSwappableArea : '';
      },
      trigger: () => {
        return document.querySelector(this.SELECTORS.main) ? document.querySelector(this.SELECTORS.main).dataset.vmTrigger : '';
      },
      save: () => {
        return document.querySelector(this.SELECTORS.main) ? document.querySelector(this.SELECTORS.main).dataset.vmSave : '';
      },
      reset: () => {
        return document.querySelector(this.SELECTORS.main) ? document.querySelector(this.SELECTORS.main).dataset.vmReset : '';
      },
      selectable: () => {
        return document.querySelector(this.SELECTORS.main) ? document.querySelector(this.SELECTORS.main).dataset.vmSelectable : '';
      },
      message: () => {
        return document.querySelector(this.SELECTORS.main) ? document.querySelector(this.SELECTORS.main).dataset.vmMessage : '';
      }
    }
  }

  get MARKUP() {
    return {
      deleteButton: () => {
        let button = document.createElement('button');
        button.classList.add('js-remove-element', 'vm-remove', 'icon-close');
        button.addEventListener('click', e => {
          e.stopPropagation();
          const el = e.currentTarget.parentElement;
          const mainEl = this.mainContainer.querySelector(`[data-vm-code="${el.getAttribute('data-vm-code')}"]`);
          this.swappableArea.removeChild(el);
          mainEl.classList.remove(this.CLASSES.selected);
          this.swappableArea.childNodes.length === 0 ? this.saved = true : this.saved = false
        });
        return button;
      }
    }
  }

  get CLASSES() {
    return {
      selected: 'is-selected',
      visible: 'is-visible'
    }
  }

  constructor() {
    super();
    this.saved = true;
    this.mainContainer = document.querySelector(this.SELECTORS.mainContainer);
  }

  //used with previous method
  // toggleSelect(element) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       let res = {
  //         element: element
  //       };
  //
  //       if (element.classList.contains(this.CLASSES.selected)) {
  //         element.classList.remove(this.CLASSES.selected);
  //         res['remove'] = true;
  //       } else {
  //         element.classList.add(this.CLASSES.selected);
  //         res['remove'] = false;
  //       }
  //       resolve(res);
  //     } catch (e) {
  //       reject(e)
  //     }
  //   });
  // }

  showMessage(str) {
    const message = document.querySelector(this.SELECTORS.message());
    message.innerHTML = str;

    setTimeout(() => {
      message.classList.add(this.CLASSES.visible);
    }, 200);

    setTimeout(() => {
      message.classList.remove(this.CLASSES.visible);
    }, 1500);
  }

  // initSelectable() {
  //   const selectableElements = document.querySelectorAll(this.SELECTORS.selectable());
  //
  //   selectableElements.forEach(el => {
  //     el.addEventListener('click', (event) => {
  //       event.preventDefault();
  //       this.toggleSelect(event.currentTarget).then(({element, remove}) => {
  //         if (remove) {
  //           const child = this.swappableArea.querySelector(`[data-vm-code="${element.getAttribute('data-vm-code')}"]`);
  //           this.swappableArea.removeChild(child);
  //         } else {
  //           if( $(element).closest('.js-swappable-area').length>0){return;}
  //           const clone = element.cloneNode(true);
  //           clone.classList.remove(this.CLASSES.selected);
  //           clone.appendChild(this.MARKUP.deleteButton());
  //           this.swappableArea.append(clone);
  //         }
  //
  //         this.swappableArea.childNodes.length === 0 ? this.saved = true : this.saved = false
  //
  //       });
  //     })
  //   })
  // }

  initSelectable() {
    //const selectableElements = document.querySelectorAll(this.SELECTORS.selectable());
    let selectableItem =`${this.SELECTORS.mainContainer} ${this.SELECTORS.selectable()}`;
    const selectableElements = document.querySelectorAll(selectableItem);

    selectableElements.forEach(el => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        el.classList.add(this.CLASSES.selected);
        const clone = el.cloneNode(true);
        clone.classList.remove(this.CLASSES.selected);
        clone.appendChild(this.MARKUP.deleteButton());
        this.swappableArea.append(clone);

        this.swappableArea.childNodes.length === 0 ? this.saved = true : this.saved = false

      });
    })
  }

  disableVm() {
    let body = document.querySelector('body');
    body.classList.remove('visual-merchandaising-enabled');
    this.swappable.destroy();
    console.log('disabled');
  }

  initVm() {
    const body = document.querySelector('body');
    body.classList.add('visual-merchandaising-enabled');
    this.swappable = new Sortable(document.querySelectorAll(this.SELECTORS.swappableArea()), {
      draggable: 'a.product-card'
    });

    this.swappable.on('swappable:swapped', () => this.saved = false);

    this.initSelectable();
  }

  reset() {
    const data = {
      productcodes: [],
      category: document.querySelector(this.SELECTORS.main).dataset.vmCategoryCode
    };

    return $.ajax({
      type: "POST",
      url: '/action/admin/categorysort',
      data: data,
      traditional: true,
      complete:function() {
        location.reload();
      }
    })
  }

  saveList() {
    const srtedElements = this.swappableArea.querySelectorAll(this.SELECTORS.codes);
    if (!srtedElements) return this.showMessage('no elements selected');
    const codes = [...srtedElements].map(el => {
      return el.dataset.vmCode;
    });

    const data = {
      productcodes: codes,
      category: document.querySelector(this.SELECTORS.main).dataset.vmCategoryCode
    };

    return $.ajax({
      type: "POST",
      url: '/action/admin/categorysort',
      data: data,
      traditional: true
    });

  }


  bindEvents() {
    let saveTriggers = document.querySelectorAll(this.SELECTORS.save());
    let resetTrigger = document.querySelector(this.SELECTORS.reset());

    resetTrigger.addEventListener('click', (event) => {
      this.reset().then(res => {
        this.saved = true;
        this.showMessage('reset');
      })
    });

    saveTriggers.forEach(save => {
      save.addEventListener('click', (event) => {
        event.preventDefault();
        if (!event.currentTarget.href) {
          return this.saveList().then(res => {
            this.saved = true;
            this.showMessage('saved');
          });
        } else if (event.currentTarget.href && !this.saved) {
          if (confirm('Do you want to exit without save?')) {
            window.location.href = event.currentTarget.href;
          }
        } else {
          window.location.href = event.currentTarget.href;
        }
      });
    });
  }

  selectElement() {
    const listingContainer = document.querySelector(this.SELECTORS.mainContainer);
    const orderedCards = this.swappableArea.querySelectorAll('a.product-card');

    orderedCards.forEach(card => {
      const cardSelector = `[data-vm-code="${card.getAttribute('data-vm-code')}"]`;
      const listingCard = listingContainer.querySelector(cardSelector);
      card.appendChild(this.MARKUP.deleteButton());
      if (listingCard) listingCard.classList.add(this.CLASSES.selected);
    });
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) {
      this.swappableArea = this.SELECTORS.swappableArea() ? document.querySelector(this.SELECTORS.swappableArea()) : null;
      this.bindEvents();
      this.initVm();
      this.selectElement();
    }
  }
}
